import React from "react";
import CreateLoan from "./CreateLoan";
import { Col, Row } from "react-bootstrap";
import { Strings } from "../../resources/i18n/i18n";
import { bindActionCreators } from "redux";
import withHOC from "../../HOC/HOC";
import { connect } from "react-redux";
import { API_ERROR_CODE, OPERATION_STATUS } from "../../config/axios.init";
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import { getAllCategoriesAction, getProductCatalogAction } from "../ProductCatalog/ProductCatalogActions";
import _ from "lodash";
import { Box, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled } from "@mui/material";
// Loan type icons
import loanTypeNotSelected from "../../resources/images/Loan_Type_Not_Visited 1.svg";
import loanTypeSelected from "../../resources/images/Loan_Type_Visited 1.svg";
import loanTypeSuccess from "../../resources/images/Loan_Type_Completed 1.svg";
// Credit product icons
import creditProductSelected from "../../resources/images/ic_credit_products_selected@3x.png";
import creditProductSuccess from "../../resources/images/ic_credit_products_success@2x.png"

// Basic information icons
import basicInformtaion from "../../resources/images/ic_basic_info@3x.png";
import basicInformtaionSelected from "../../resources/images/ic_basic_info_selected@3x.png";
import basicInformtaionSuccess from "../../resources/images/ic_basic_info_success@2x.png";

// References icon
import references from "../../resources/images/ic_references@3x.png";
import referencesSelected from "../../resources/images/ic_references_selected@3x.png";
import referencesSuccess from "../../resources/images/ic_references_success@2x.png";

// Financial information
import financialInformation from "../../resources/images/ic_financial_info@3x.png";
import financialInformationSelected from "../../resources/images/ic_financial_info_selected@3x.png";
import financialInformationSuccess from "../../resources/images/ic_financial_info_success@2x.png";

// Site visit
import siteVisitUnselected from "../../resources/images/ic_site_visit@3x.png";
import siteVisitSelected from "../../resources/images/ic_site_visit_selected@3x.png";
import siteVisitSuccess from "../../resources/images/ic_site_visit_success@2x.png";

// Evidence
import evidence from "../../resources/images/ic_evidence@3x.png"
import evidenceSelected from "../../resources/images/ic_evidence_selected@3x.png";
import evidenceSuccess from "../../resources/images/ic_evidence_success@2x.png";

// Check icon
import CheckIcon from "../../resources/images/ic_checkin_status@3x.png"
import { API_CALL_NOT_ALLOWED_STATUS, LOAN_CREATION_STEPS, LOAN_CREATION_STEPS_MAP, LOAN_STATUS } from "./CreateLoanConstants";
import { LOAN_TYPES } from "../AnalystApproval/Constants";
import { getMotorcycleCatalogAction, getMotorcycleCategoriesAction } from "../MotorcycleCatalog/MotorcycleCatalogueAction";
import Utility from "../../utils/Utility";
import { DEFAULT_PAGINATION_ACTIVE_PAGE, DEFAULT_PAGINATION_RECORDS_COUNT } from "../CustomUIComponents/Pagination/PaginationConstants";
import { clearCreditProductInputDataForEditAction, clearLoanDetailsAction, clearsetBasicInformationValuesAction, clearsetCreditProductValuesAction, clearsetEvidenceAction, clearsetFinancialInformationAction, clearsetReferencesValuesAction, clearsetSiteVisitAction, getAllInvoicesForMinimartAction, getLastDisbursedLoanIdAction, getLastLoanDetailsAction, setLoanDetailsAction, suggestedAmountAction, updateLoanStatusAction } from "./CreateLoanAction";
import { getDropdownValuesForLoanApplicationFormAction, getFrequencyConfigurationAction } from "../AnalystApproval/AnalystApprovalAction";
import { getLoanApplicationDetailsByIdAction } from "../ViewLoanApplication/ViewLoanApplicationAction";
import { LOAN_APPLICATION_STATUS } from "../../constants/appConstants";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 20,
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 2,
        border: 0,
        backgroundColor: '#ccc',
        borderRadius: 1,
    },
}));

const CustomStepIcon = (props) => {
    const { active, completed, icon, allLoanDetails, basicInfo, loanInfo, additionalInfo, expenses, siteVisit, docPrefillData, loanTypeStepCompleted } = props;


    const stepIcons = {
        1: {
            unselected: loanTypeNotSelected,
            selected: loanTypeSelected,
            success: loanTypeSuccess,
            hasCompleted: loanTypeStepCompleted,
        },
        2: {
            unselected: creditProductSelected,
            selected: creditProductSelected,
            success: creditProductSuccess,
            hasCompleted: loanInfo?.prefillData,
        },
        3: {
            unselected: basicInformtaion,
            selected: basicInformtaionSelected,
            success: basicInformtaionSuccess,
            hasCompleted: basicInfo?.prefillData,
        },
        4: {
            unselected: references,
            selected: referencesSelected,
            success: referencesSuccess,
            hasCompleted: additionalInfo?.prefillData,
        },
        5: {
            unselected: financialInformation,
            selected: financialInformationSelected,
            success: financialInformationSuccess,
            hasCompleted: expenses?.prefillData,
        },
        6: {
            unselected: siteVisitUnselected,
            selected: siteVisitSelected,
            success: siteVisitSuccess,
            hasCompleted: siteVisit.prefillData,
        },
        7: {
            unselected: evidence,
            selected: evidenceSelected,
            success: evidenceSuccess,
            hasCompleted: docPrefillData,
        },


    };
    const stepIconSet = stepIcons[icon];
    let iconSrc = stepIconSet.unselected;
    let hasCompleted = stepIconSet.hasCompleted;
    let showCheckIcon = completed || hasCompleted;
    if (icon === 2) {
        if (loanInfo?.prefillData) {
            showCheckIcon = true;
        }
        else {
            showCheckIcon = false;
        }
    } else if (icon === 7 && allLoanDetails && allLoanDetails[LOAN_CREATION_STEPS_MAP[6]]?.length > 3) {
        showCheckIcon = true;
    }
    let showCrediProductSuccessIcon = icon === 2 && loanInfo?.prefillData;
    if (active) {
        iconSrc = stepIconSet.selected;
    } else if (completed || hasCompleted) {
        if (icon !== 7 && icon !== 2) {
            iconSrc = stepIconSet.success;
        } else if (showCrediProductSuccessIcon) {
            iconSrc = stepIconSet.success;
        }
        else if ((icon === 7 && allLoanDetails && allLoanDetails[LOAN_CREATION_STEPS_MAP[6]]?.length > 3) || (icon === 7 && docPrefillData)) {
            iconSrc = stepIconSet.success
        }
    }
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 40,
                height: 40,
                borderRadius: "50%",
                color: "white",
                position: "relative",
            }}
        >
            <img
                src={iconSrc}
                alt={`step-icon-${icon}`}
                style={{ width: "100%", height: "100%" }}
            />
            {/* || ((allLoanDetails && icon === 7) ? allLoanDetails[LOAN_CREATION_STEPS_MAP[icon - 1]]?.length > 0 : (allLoanDetails && allLoanDetails[LOAN_CREATION_STEPS_MAP[icon - 1]])) */}
            {showCheckIcon && (
                <img
                    src={CheckIcon}
                    alt="check"
                    style={{
                        position: "absolute",
                        bottom: "0.1em",
                        right: "0.1em",
                        width: "40%",
                        height: "40%",
                        backgroundColor: "white",
                        borderRadius: "50%",
                        boxShadow: "0 0 2px rgba(0,0,0,0.15)",
                        border: "1px solid #fff",
                    }}
                />
            )}
        </Box>
    );
};
class CreateLoanContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            errorMessage: "",
            showLoadingModal: false,
            selectedLoanType: "",
            row: [],
            numberOfPages: 1,
            minimart: props.singleMiniMartDetails,
            eligibleLoantypes: "",
            poorGrades: [],
            loanType: {
                frequencyList: [],
                SearchFilter: {
                    productModel: "",
                    motorModel: "",
                    productCategory: "",
                    motorCategory: "",
                    model: "",
                    category: "",
                    activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
                    recordsPerPage: DEFAULT_PAGINATION_RECORDS_COUNT,
                },
                categoryList: "",
                motorCategotyList: [],
                invoiceList: [],
            },
            lastDisbursedLoanId: "",
            lastDisbursedLoanDetails: [],
            loanApplicationDetails: null,
            dropdownValues: [],
            suggestedAmount: null,
            existingLoanCreatedInvoice: null,
            existingLoanCreatedAmount: null,
            factoringLoanApplicationId: null,
            selectedLoanData: null,
            loanTypeStepCompleted: false,
            invalidFormField: [],
            existingSelectedLoanDetail: null,
            existingFactoringSelectedLoanDetail: null,
            toShowToast: false,
            successToastMessage: "",
            level: "",
        };
    }
    componentDidMount() {
        this.getLastDisbursedLoanId();
        if (!this.props.selectedLoanType) {
            this.props.clearLoanDetailsAction();
            this.props.clearCreditProductInputDataForEditAction();
        }
    }

    componentWillUnmount() {
        this.props.clearLoanDetailsAction();
        this.props.clearCreditProductInputDataForEditAction();
    }

    getLastLoanDetails = () => {
        this.setState({
            showLoadingModal: true
        });
        let request = this.state.minimart.minimartDetails.id;
        getLastLoanDetailsAction(request, (responseData) => {
            if (responseData.status === OPERATION_STATUS.SUCCESS) {
                let existingSelectedLoanDetail = responseData.data.data?.find((loan) => {
                    return this.state.selectedLoanType ? this.state.selectedLoanType === loan.tp && loan.fd === null : null;
                });
                this.setState({
                    lastDisbursedLoanDetails: responseData.data.data,
                    showLoadingModal: false,
                    existingSelectedLoanDetail: existingSelectedLoanDetail,
                });
            } else {
                this.setState({
                    errorMessage: responseData.error.message,
                    showLoadingModal: false,
                });
            }
        })
    }
    updateLoanStatus = (callback) => {
        this.setState({
            showLoadingModal: true,
        })
        const request = {
            applicationId: this.state.existingSelectedLoanDetail.appId,
            status: LOAN_APPLICATION_STATUS.dismissed,
        }
        updateLoanStatusAction(request, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    toShowToast: true,
                    successToastMessage: Strings("loanDismissedSuccessfully"),
                    level: "success",
                }, () => {
                    this.setState({
                        showLoadingModal: false,
                    }, () => {
                        this.getLastDisbursedLoanId();
                        this.clearStates()
                        callback();
                    });
                });
            } else {
                this.setState({
                    errorMessage: response.error?.message,
                    showLoadingModal: false,
                }, () => {
                    callback();
                });
            }
        });
    }
    getLastDisbursedLoanId = () => {
        this.setState({
            showLoadingModal: true,
        })
        let request = this.state.minimart.minimartDetails.id;
        getLastDisbursedLoanIdAction(request, (responseData) => {
            if (responseData.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    lastDisbursedLoanId: responseData.data.data.id,
                    showLoadingModal: false,
                }, () => {
                    this.getLastLoanDetails()
                });
            } else if (responseData.error.code === API_ERROR_CODE.LOAN_NOT_FOUND) {
                this.setState({
                    showLoadingModal: false,
                }, () => {
                    this.getLastLoanDetails()
                })
            }
            else {
                this.setState({
                    errorMessage: responseData.error.message,
                    showLoadingModal: false,
                });
            }
        })

    }
    getLoanApplicationDetailsById = (id, st) => {
        if (!id) {
            this.getDropdownValuesForLoanApplicationForm();
        }
        else {
            this.setState({ showLoadingModal: true });
            getLoanApplicationDetailsByIdAction(id, (Response) => {
                if (Response.status === OPERATION_STATUS.SUCCESS) {
                    this.setState({
                        errorMessage: "",
                        showLoadingModal: false,
                        loanApplicationDetails: Response.data.data,
                    }, () => {
                        let applyLoanConfig = {
                            loanApplicationId: id,
                            minimartCode: this.state.minimart.minimartDetails.id,
                            loanStatus: Response.data.data.loanStatus,
                            type: Response.data.data.loanType,
                            docRequire: Response.data.data.docRequire,
                            externalInvoiceRequire: Response.data.data.externalInvoiceRequire,
                        }

                        let loanDetail = Response.data.data;

                        loanDetail.applyLoanConfig = applyLoanConfig;
                        if (Array.isArray(loanDetail.documents) && !(API_CALL_NOT_ALLOWED_STATUS.includes(st))) {
                            loanDetail.documents = loanDetail.documents.filter(
                                doc => doc.type !== "APPLICATION_SIGNATURE"
                            );
                        }

                        this.props.setLoanDetailsAction(loanDetail);
                        this.getDropdownValuesForLoanApplicationForm();
                    });
                } else {
                    this.setState(
                        {
                            showLoadingModal: false,
                            errorMessage: Response.error.message,
                        },
                    );
                }
            });
        }
    };

    getDropdownValuesForLoanApplicationForm = () => {
        this.setState({
            showLoadingModal: true,
        })
        getDropdownValuesForLoanApplicationFormAction(this.state.minimart.minimartDetails.id, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                let dropdownValues = response.data.data.dcsm;
                this.setState({
                    dropdownValues,
                    showLoadingModal: false
                }, () => {
                    this.handleNext();
                });
            } else {
                this.setState({
                    errorMessage: response.error.message,
                    showLoadingModal: false
                });
            }
        });
    }

    getSuggestedAmounAPI = (requestData) => {
        suggestedAmountAction(requestData, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    suggestedAmount: response.data.data?.suggestedAmount
                })
            } else {
                this.setState({
                    errorMessage: response.error.message,
                });
            }
        })
    }
    handleProductSearchFilter = (searchFilterObject) => {
        this.setState({
            showLoadingModal: true,
            errorMessage: "",
        });
        getProductCatalogAction(searchFilterObject, (Response) => {
            if (Response.status === OPERATION_STATUS.SUCCESS) {
                this.setState(prevState => ({
                    showLoadingModal: false,
                    errorMessage: "",
                    numberOfPages: Response.data.data.np,
                    loanType: {
                        ...prevState.loanType,
                        SearchFilter: {
                            ...prevState.loanType.SearchFilter,
                            numberOfPages: Response.data.data.np,
                        }
                    }
                }), () => {
                    this.createRows(Response.data.data.li);
                });
            } else {
                this.setState({
                    errorMessage: Response.error.message,
                    showLoadingModal: false,
                });
            }
        });

    };
    handleMotoCycyleSearchFilter = (searchFilterObject) => {
        this.setState({
            showLoadingModal: true,
            errorMessage: "",
        });
        getMotorcycleCatalogAction(searchFilterObject, (apiResponse) => {
            this.apiProcessCounter = this.apiProcessCounter - 1;

            if (apiResponse.status === OPERATION_STATUS.SUCCESS) {
                let motorcycleData = [];

                for (const motorcycle of apiResponse.data.data.li) {
                    let motorCycleProduct = { ...motorcycle };
                    if (motorCycleProduct.img) {
                        // S3 URL decryption
                        motorCycleProduct.img = Utility.getDecryptedData(motorCycleProduct.img);
                    }
                    motorcycleData.push(motorCycleProduct);
                }

                this.setState({
                    row: motorcycleData,
                    errorMessage: "",
                    showLoadingModal: false,
                    numberOfPages: apiResponse.data.data.np,
                })

            } else {
                this.setState({
                    row: [],
                    errorMessage: apiResponse.error.message,
                    showLoadingModal: false,
                    numberOfPages: 1,
                });
            }
        });

    }
    getAllMotorCategories = () => {
        this.setState({ showLoadingModal: true });
        getMotorcycleCategoriesAction((apiResponse) => {
            if (apiResponse.status === OPERATION_STATUS.SUCCESS) {
                this.setState(prevState => ({
                    showLoadingModal: false,
                    loanType: {
                        ...prevState.loanType,
                        categoryList: apiResponse.data.data,
                    },
                    errorMessage: "",
                }));
            } else {
                this.setState(prevState => ({
                    showLoadingModal: false,
                    loanType: {
                        ...prevState.loanType,
                        categoryList: [],
                    },
                    errorMessage: apiResponse.error.message,
                }));
            }
        });
    };

    getAllCategories = () => {
        this.setState({ showLoadingModal: true });
        getAllCategoriesAction((Response) => {
            if (Response.status === OPERATION_STATUS.SUCCESS) {
                const fetchedCategories = Response.data.data;
                this.setState(prevState => ({
                    showLoadingModal: false,
                    loanType: {
                        ...prevState.loanType,
                        categoryList: fetchedCategories,
                    },
                    errorMessage: "",
                }));
            } else {
                this.setState(prevState => ({
                    showLoadingModal: false,
                    loanType: {
                        ...prevState.loanType,
                        categoryList: [],
                    },
                    errorMessage: Response.error.message,
                }));
            }
        });
    };
    getFrequencyList = (request) => {
        let requestData = request;
        requestData.level = this.props.level;
        requestData.minimartId = this.state.minimart.minimartDetails.id;
        requestData.level = this.state.minimart.creditLimit.eligibility;
        this.setState({
            showLoadingModal: true,
        });
        getFrequencyConfigurationAction(requestData, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.setState(prevState => ({
                    showLoadingModal: false,
                    errorMessage: "",
                    loanType: {
                        ...prevState.loanType,
                        frequencyList: response.data.data.frqs
                    },
                }));
            } else {
                this.setState({
                    errorMessage: response.error.message,
                    showLoadingModal: false,
                });
            }
        });

    };
    createRows = (responseData) => {
        let rows = [],
            productCatalog = responseData;
        _.forEach(productCatalog, (product) => {
            rows.push({
                category: product.cat,
                id: product.id,
                productNameAndDescription: {
                    productName: product.pn,
                    description: product.dc,
                },
                model: product.mo,
                cost: product.co,
                status: product.st,
                ProductPreservedData: product,
                branchIds: product.bid,
            });
        });

        this.setState({
            row: rows
        });
    };
    factoringLoanTypeAction = () => {
        const today = new Date();
        const todayTimestamp = today.getTime();
        let requestObj = {
            search: {
                minimartCode: this.props.singleMiniMartDetails.minimartDetails.code ? this.props.singleMiniMartDetails.minimartDetails.code : undefined,
                status: LOAN_STATUS,
                fromDate: todayTimestamp,
                toDate: todayTimestamp
            }
        };
        this.getInvoices(requestObj);
    }
    selectedLoanTypeAction = (loanType) => {
        let searchFilterObject = {
            search: {
                minimartId: this.state.minimart.minimartDetails.id,
            },
            limit: 10,
            offset: DEFAULT_PAGINATION_ACTIVE_PAGE - 1
        };
        this.getSuggestedAmounAPI({ type: loanType, mid: this.state.minimart.minimartDetails.id })
        if (
            loanType === LOAN_TYPES.CONSUMER ||
            loanType === LOAN_TYPES.MOTORCYCLE_LOAN ||
            loanType === LOAN_TYPES.FACTORING
        ) {
            // Common category fetch logic
            if (loanType === LOAN_TYPES.CONSUMER) {
                this.getAllCategories();
                this.handleProductSearchFilter(searchFilterObject);
            } else if (loanType === LOAN_TYPES.MOTORCYCLE_LOAN) {
                this.getAllMotorCategories();
                this.handleMotoCycyleSearchFilter(searchFilterObject);
            } else if (loanType === LOAN_TYPES.FACTORING && this.props.singleMiniMartDetails.minimartDetails.code) {
                this.factoringLoanTypeAction();
            }

        }
    }
    getInvoices = (requestData) => {
        this.setState({
            showLoadingModal: true,
        });
        getAllInvoicesForMinimartAction(requestData, (Response) => {
            if (Response.status === OPERATION_STATUS.SUCCESS) {

                this.setState({
                    showLoadingModal: false,
                    errorMessage: "",
                    row: Response.data.data.invoices,
                }, () => {
                    this.showLoanCreatedInvoice(this.state.row)
                });
            } else {
                this.setState({
                    errorMessage: Response.error.message,
                    showLoadingModal: false,
                });
            }
        })
    }
    resetSearchFilters = (callback) => {
        const defaultSearchFilter = {
            productModel: "",
            motorModel: "",
            productCategory: "",
            motorCategory: "",
            model: "",
            category: "",
            activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
            recordsPerPage: DEFAULT_PAGINATION_RECORDS_COUNT,
        };

        this.setState(prevState => ({
            loanType: {
                ...prevState.loanType,
                SearchFilter: {
                    ...defaultSearchFilter
                }
            },
            errorMessage: "",
        }), () => {
            if (typeof callback === 'function') {
                callback();
            }
        });
    };
    showLoanCreatedInvoice = (invoiceData) => {
        let selectedInvoice = invoiceData?.find((invoice) => invoice.loanApplicationId);
        let existingLoanCreatedInvoice = selectedInvoice?.number;
        let existingLoanCreatedAmount = selectedInvoice?.amount;
        let factoringLoanApplicationId = selectedInvoice?.loanApplicationId;
        let existingFactoringSelectedLoanDetail = null;
        if (selectedInvoice) {
            existingFactoringSelectedLoanDetail = {
                tp: LOAN_TYPES.FACTORING,
                st: selectedInvoice?.status,
                apAmt: selectedInvoice?.amount,
                number: selectedInvoice?.number,
            };
        }
        this.setState({
            existingLoanCreatedInvoice,
            existingLoanCreatedAmount,
            factoringLoanApplicationId,
            existingFactoringSelectedLoanDetail,
        })
    }

    clearStates = () => {
        this.props.clearLoanDetailsAction();
        this.props.clearsetCreditProductValuesAction();
        this.props.clearsetBasicInformationValuesAction();
        this.props.clearsetReferencesValuesAction();
        this.props.clearsetFinancialInformationAction();
        this.props.clearsetSiteVisitAction();
        this.props.clearsetEvidenceAction();
        this.props.clearCreditProductInputDataForEditAction();
    }

    handleLoanTypeRadioChange = (event) => {
        this.clearStates();
        this.setState({
            loanTypeStepCompleted: true,
        });

        const selectedLoanType = event.target.value;
        const defaultSearchFilter = {
            productModel: "",
            motorModel: "",
            productCategory: "",
            motorCategory: "",
            model: "",
            category: "",
            activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
            recordsPerPage: DEFAULT_PAGINATION_RECORDS_COUNT,
        };
        let existingSelectedLoanDetail = this.state.lastDisbursedLoanDetails?.find((loan) => {
            return selectedLoanType === loan.tp && loan.fd === null;
        });

        this.setState(prevState => ({
            selectedLoanType,
            row: [],
            loanType: {
                ...prevState.loanType,
                SearchFilter: defaultSearchFilter,
            },
            loanApplicationDetails: null,
            dropdownValues: [],
            existingSelectedLoanDetail: existingSelectedLoanDetail,
        }), () => {
            this.selectedLoanTypeAction(this.state.selectedLoanType);
        });
    };
    setSelectedLoanData = () => {
        let loanDetails = {};
        this.state.lastDisbursedLoanDetails.map((loans) => {
            if (this.state.selectedLoanType === loans.tp) {
                loanDetails = loans;
            }
            return loanDetails;
        })
        this.setState({
            selectedLoanData: loanDetails
        })
    }

    renderSteps = () => {
        const { activeStep, selectedLoanType } = this.state;
        const isPersonalLoan = selectedLoanType === LOAN_TYPES.PERSONAL_LOAN;
        const displaySteps = isPersonalLoan
            ? LOAN_CREATION_STEPS.filter(step => step !== "SiteVisit")
            : LOAN_CREATION_STEPS;
        const displayActiveStep = (isPersonalLoan && activeStep > 4) ? activeStep - 1 : activeStep;
        return (
            <Row className="">
                <Stepper activeStep={displayActiveStep} alternativeLabel connector={<CustomConnector />} >
                    {displaySteps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel StepIconComponent={(props) => <CustomStepIcon
                                {...props}
                                allLoanDetails={this.props.allLoanDetails}
                                basicInfo={this.props.basicInfo}
                                loanInfo={this.props.loanInfo}
                                siteVisit={this.props.siteVisit}
                                additionalInfo={this.props.additionalInfo}
                                expenses={this.props.expenses}
                                docPrefillData={this.props.docPrefillData}
                                loanTypeStepCompleted={this.state.loanTypeStepCompleted}
                            />}>{Strings(label)}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Col className="ps-4 pe-4">
                    <hr className="opacity-100" />
                </Col>
            </Row>
        )
    }
    redirectToLoanTypeStep = () => {
        this.clearStates();
        this.setState({
            activeStep: 0,
            selectedLoanType:"",
            loanTypeStepCompleted:false
        });
    }
    handleBack = () => {
        const { activeStep, selectedLoanType } = this.state;
        const decrement = (selectedLoanType === LOAN_TYPES.PERSONAL_LOAN && activeStep === 6) ? 2 : 1;
        this.setState((prevState) => ({
            activeStep: prevState.activeStep - decrement
        }));
    };
    handleNext = () => {
        const { activeStep, selectedLoanType } = this.state;
        const increment = (selectedLoanType === LOAN_TYPES.PERSONAL_LOAN && activeStep === 4) ? 2 : 1;
        this.setState((prevState) => ({
            activeStep: prevState.activeStep + increment
        }));
    };
    handleFiltersChange = (key, event) => {
        this.setState(prevState => ({
            loanType: {
                ...prevState.loanType,
                SearchFilter: {
                    ...prevState.loanType.SearchFilter,
                    [key]: event.target.value
                }
            }
        }));
    };
    onPaginationChange = ({ page, pageLength }, callback) => {
        this.setState(prevState => ({
            loanType: {
                ...prevState.loanType,
                SearchFilter: {
                    ...prevState.loanType.SearchFilter,
                    activePage: page,
                    recordsPerPage: pageLength,
                }
            }
        }), () => {
            if (callback) callback();
        });
    };

    showLoadingModal = () => {
        this.setState({
            showLoadingModal: true
        })
    }
    closeLoadingModal = () => {
        this.setState({
            showLoadingModal: false
        })
    }
    goBack = () => {
        this.props.history.goBack();
    };

    render() {
        let existingSelectedLoanDetail = this.state.existingSelectedLoanDetail;
        if (this.state.selectedLoanType === LOAN_TYPES.FACTORING) {
            existingSelectedLoanDetail = this.state.existingFactoringSelectedLoanDetail;
        }
        return (
            <div>
                <LoadingModal
                    showLoadingModal={this.state.showLoadingModal}
                />
                {this.state.toShowToast && (
                    <UserNotification
                        key={this.state.successToastMessage}
                        userNotificationObj={{
                            message: this.state.successToastMessage,
                            level: this.state.level,
                        }}
                    />
                )}
                <Row className='heading'>
                    <Col md={12}>
                        <span>
                            {Strings("createLoanHeaderLabel")}
                        </span>
                        &nbsp;:&nbsp;
                        <span>{this.state.minimart?.minimartDetails?.id}</span>

                    </Col>

                </Row>
                <div className="createLoan pt-4 pb-4">
                    {this.renderSteps()}
                    {this.props.singleMiniMartDetails?.eligibleLoanTypes && <CreateLoan
                        minimart={this.state.minimart}
                        eligibleLoantypes={this.props.singleMiniMartDetails.eligibleLoanTypes}
                        getAllCategories={this.getAllCategories}
                        getAllMotorCategories={this.getAllMotorCategories}
                        productCategories={this.state.loanType.categoryList}
                        handleProductSearchFilter={this.handleProductSearchFilter}
                        rows={this.state.row}
                        activeStep={this.state.activeStep}
                        handleLoanTypeRadioChange={this.handleLoanTypeRadioChange}
                        selectedLoanType={this.state.selectedLoanType}
                        selectedLoanTypeAction={this.selectedLoanTypeAction}
                        numberOfPages={this.state.numberOfPages}
                        handleMotoCycyleSearchFilter={this.handleMotoCycyleSearchFilter}
                        loanTypeObj={this.state.loanType}
                        handleFiltersChange={this.handleFiltersChange}
                        onPaginationChange={this.onPaginationChange}
                        resetSearchFilters={this.resetSearchFilters}
                        getFrequencyList={this.getFrequencyList}
                        frequencyList={this.state.loanType.frequencyList}
                        isHistory={this.props.isHistory}
                        lastDisbursedLoanDetails={this.state.lastDisbursedLoanDetails}
                        lastDisbursedLoanId={this.state.lastDisbursedLoanId}
                        showLoadingModal={this.showLoadingModal}
                        closeLoadingModal={this.closeLoadingModal}
                        loanApplicationDetails={this.state.loanApplicationDetails}
                        getLoanApplicationDetails={this.getLoanApplicationDetailsById}
                        suggestedAmount={this.state.suggestedAmount}
                        handleNext={this.handleNext}
                        dropdownValues={this.state.dropdownValues}
                        getLastDisbursedLoanId={this.getLastDisbursedLoanId}

                        singleMiniMartDetails={this.props.singleMiniMartDetails}
                        handleBack={this.handleBack}
                        existingLoanCreatedInvoice={this.state.existingLoanCreatedInvoice}
                        existingLoanCreatedAmount={this.state.existingLoanCreatedAmount}
                        factoringLoanApplicationId={this.state.factoringLoanApplicationId}
                        setSelectedLoanData={this.setSelectedLoanData}
                        loanApplicationId={this.props.applyLoanConfig.loanApplicationId}
                        goBack={this.goBack}
                        redirectToLoanTypeStep={this.redirectToLoanTypeStep}
                        factoringLoanTypeAction={this.factoringLoanTypeAction}
                        clearCreditProductInputDataForEditAction={this.props.clearCreditProductInputDataForEditAction}
                        invalidFormField={this.state.invalidFormField}
                        existingSelectedLoanDetail={existingSelectedLoanDetail}
                        updateLoanStatus={this.updateLoanStatus}
                        showLoadingModalState={this.state.showLoadingModal}
                    />}
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    singleMiniMart: state.minimartListReducer.singleMiniMart,
    singleMiniMartDetails: state.minimartListReducer.singleMiniMartDetails,
    isNewMinimart: state.minimartListReducer.isNewMinimart,
    isHistory: state.loanDetailsReducer.isHistory,
    allLoanDetails: state.loanDetailsReducer.allLoanDetails,
    basicInfo: state.loanDetailsReducer.basicInfo,
    loanInfo: state.loanDetailsReducer.loanInfo,
    additionalInfo: state.loanDetailsReducer.additionalInfo,
    expenses: state.loanDetailsReducer.expenses,
    siteVisit: state.loanDetailsReducer.siteVisit,
    docPrefillData: state.loanDetailsReducer.docPrefillData,
    loanApplicationId: state.loanDetailsReducer.loanApplicationId,
    applyLoanConfig: state.loanDetailsReducer.applyLoanConfig,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setLoanDetailsAction,
            clearLoanDetailsAction,
            clearsetCreditProductValuesAction,
            clearsetBasicInformationValuesAction,
            clearsetReferencesValuesAction,
            clearsetFinancialInformationAction,
            clearsetSiteVisitAction,
            clearsetEvidenceAction,
            clearCreditProductInputDataForEditAction,
        },
        dispatch
    );
};

const CreateLoanContainerWrapper = withHOC(CreateLoanContainer);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateLoanContainerWrapper);